import { Component } from '@angular/core';
import { MenuItem, PrimeIcons } from 'primeng/api';

@Component({
    selector: 'app-help-menu',
    template: `
    <button pButton pRipple type="button" class="p-button-rounded p-button-text p-text-secondary" icon="pi pi-question" title="Help Menu" (click)="menu.toggle($event)"></button>
    <p-menu #menu [popup]="true" [model]="items"></p-menu>
  `,
    styles: [`
    button {
      background: transparent;
      border-color: transparent;
    }
  `],
    standalone: false
})
export class HelpMenuComponent {
  items: MenuItem[]= [
    // {
    //   label: 'Quickstart Guide',
    //   icon: PrimeIcons.BOOK,
    //   routerLink: '/quickstart'
    // },
    {
      label: 'Changelog',
      icon: PrimeIcons.CLOCK,
      routerLink: '/changelog'
    },
    {
      label: 'About',
      icon: PrimeIcons.QUESTION,
      routerLink: '/about'
    },
    {
      label: 'Return to Designs',
      icon: PrimeIcons.ARROW_LEFT,
      routerLink: ['/designs']
    }
  ];
  
}
